import styled, { css } from 'styled-components'
import { Icon, Button } from '@sketch/components'

export const NavbarItem = styled.div`
  margin: 0 8px;
`
// This is used to align the action buttons on the canvas header
// with the rest of the elements. And also to adjust the spacing with
// the right separator
export const ActionsNavbarItem = styled(NavbarItem)`
  display: flex;
  margin-right: 0;
`

export const NavbarBackButtonItem = styled(NavbarItem)`
  margin: 0 8px 0 0;
  line-height: 1;
`

export const AddAnnotationText = styled(NavbarItem)`
  font-size: 0.8125rem;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.foreground.secondary.A};
`

export const MiddleContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
`

export const IconButton = styled(Button).attrs({ size: '32' })<{
  active?: boolean
}>(
  ({ theme, active }) => css`
    padding: 4px 8px;
    box-shadow: none;
    border: none;
    position: relative;
    width: 40px;
    background-color: transparent;

    &:hover {
      background-color: ${theme.colors.state.hover};
    }

    ${Icon} {
      color: ${active
        ? theme.colors.sketch.A
        : theme.colors.foreground.secondary.D};
      height: 100%;
      width: 100%;
      opacity: 1;

      &:hover {
        color: ${active ? undefined : theme.colors.foreground.secondary.A};
      }
    }
  `
)
